module.exports = __webpack_public_path__ + "media/images/pic/godzilla/beast-91333da3f493f037cce0c9f28404ab01.png";